import React, { useEffect, useState } from "react";
import { Box, Typography, Dialog } from "@mui/material";
import toast from "react-hot-toast";

export default function LinkPayment({
  isPaymentLinked,
  className,
  style,
  onAddChefAccountSuccess,
}) {

  const userId = localStorage.getItem("logged_user_id");

  const [loading, setLoading] = useState(false);
  const [showPaymentsReceivableError, setShowPaymentsReceivableError] = useState(false);
  const [showEmailConfirmationError, setShowEmailConfirmationError] = useState(false);

  const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  const CLIENT_SECRET = process.env.REACT_APP_PAYPAL_SECRET_KEY;

  const PARTNER_ID = "5ZPAUD3E2QNVY";

  // ---------------- PAYPAL ONBOARDING ----------------
  const handleOnboarding = async () => {
    setLoading(true);

    try {

      const basicAuth = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);

      const tokenRes = await fetch("https://api-m.paypal.com/v1/oauth2/token", {
        method: "POST",
        headers: {
          Authorization: `Basic ${basicAuth}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "grant_type=client_credentials",
      });

      const tokenData = await tokenRes.json();
      const accessToken = tokenData.access_token;

      const currentPath = window.location.pathname.startsWith("/")
        ? window.location.pathname.slice(1)
        : window.location.pathname;

      const referralRes = await fetch(
        "https://chefrepublicwebapi-dev.portalwiz.in/api/user/partner_referral",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            operations: [
              {
                operation: "API_INTEGRATION",
                api_integration_preference: {
                  rest_api_integration: {
                    integration_method: "PAYPAL",
                    integration_type: "THIRD_PARTY",
                  },
                },
              },
            ],
            products: ["PPCP", "ADVANCED_VAULTING"],
            capabilities: ["PAYPAL_WALLET_VAULTING_ADVANCED"],
            partner_config_override: {
              return_url: `https://chefrepublic-dev.portalwiz.in/${currentPath}`,
              return_url_description: "Back to Chef Republic",
            },
          }),
        }
      );

      const referralData = await referralRes.json();

      const signupLink = referralData?.signup_link;

      if (signupLink) {
        window.location.href = signupLink;
      } else {
        toast.error("PayPal onboarding failed");
      }

    } catch (err) {
      console.error("Onboarding error:", err);
    }

    setLoading(false);
  };

  // ---------------- CHECK PAYPAL STATUS ----------------
  const checkAccountStatus = async (merchantId) => {

    try {

      const basicAuth = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`);

      const tokenRes = await fetch("https://api-m.paypal.com/v1/oauth2/token", {
        method: "POST",
        headers: {
          Authorization: `Basic ${basicAuth}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "grant_type=client_credentials",
      });

      const tokenData = await tokenRes.json();
      const accessToken = tokenData.access_token;

      const statusRes = await fetch(
        `https://api-m.paypal.com/v1/customer/partners/${PARTNER_ID}/merchant-integrations/${merchantId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const statusData = await statusRes.json();

      console.log("Merchant Status:", statusData);

      if (!statusData.primary_email_confirmed) {

        await fetch(
          `${process.env.REACT_APP_BASE_URL}user/syncChefPayPalStatus`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
          }
        );

      }

      if (!statusData.payments_receivable) {
        setShowPaymentsReceivableError(true);
      } 
      else if (!statusData.primary_email_confirmed) {
        setShowEmailConfirmationError(true);
      } 
      else {
        toast.success("Merchant account linked successfully");
      }

    } catch (err) {
      console.error("Account status error:", err);
    }
  };

  // ---------------- RETURN FROM PAYPAL ----------------
  useEffect(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const merchantId = urlParams.get("merchantIdInPayPal");
    const email = urlParams.get("email");

    if (merchantId) {
      saveMerchantIdToBackend(merchantId, email);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

  }, []);

  const saveMerchantIdToBackend = async (merchantId, email) => {

    try {
  
      const response = await fetch(
        "https://chefrepublicwebapi-dev.portalwiz.in/api/user/add_chef_account",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: userId,
            merchantId,
            Email: email,
            merchantIdInPayPal: merchantId,
            permissionsGranted: true,
            accountStatus: "",
            consentStatus: "",
            isEmailConfirmed: "",
            returnMessage: ""
          }),
        }
      );
  
      const data = await response.json();
  
      console.log("Add Chef Account Response:", data);
  
      if (data.status === true) {
        if (typeof onAddChefAccountSuccess === "function") {
          onAddChefAccountSuccess();
        }
        checkAccountStatus(merchantId);
      }
  
    } catch (err) {
      console.error("Save merchant error:", err);
    }
  
  };


  

  return (
    <Box>

      <button
        type="button"
        className={className || "btn btn-orange rounded-pill mb-3"}
        disabled={isPaymentLinked}
        onClick={handleOnboarding}
        style={{
          width: "100%",
          backgroundColor: isPaymentLinked ? "#cccbcbff" : "#FF5E41",
          color: "#fff",
          cursor: isPaymentLinked ? "not-allowed" : "pointer",
          ...style,
        }}
      >
        Link Payment Method
      </button>

      {/* Payment Error Dialog */}
      <Dialog open={showPaymentsReceivableError}>
        <Box sx={{ p: 3 }}>
          <Typography color="error">
            Your PayPal account cannot receive payments.
          </Typography>
        </Box>
      </Dialog>

      {/* Email Error */}
      <Dialog open={showEmailConfirmationError}>
        <Box sx={{ p: 3 }}>
          <Typography color="error">
            Please confirm your PayPal email.
          </Typography>
        </Box>
      </Dialog>

    </Box>
  );
}